import createIcon from '../../createIcon';

/**
 * @component @name PinInvoke
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJWMThDMjIgMTkuMSAyMS4xIDIwIDIwIDIwSDRDMi45IDIwIDIgMTkuMSAyIDE4VjZDMiA0LjkgMi45IDQgNCA0SDE0VjZINFYxOEgyMFYxMkgyMlpNMjIgN0MyMiA1LjM0IDIwLjY2IDQgMTkgNEMxNy4zNCA0IDE2IDUuMzQgMTYgN0MxNiA4LjY2IDE3LjM0IDEwIDE5IDEwQzIwLjY2IDEwIDIyIDguNjYgMjIgN1pNMTEuNDcgMTIuMTJMOC42NCAxNC45NUwxMC4wNSAxNi4zNkwxMi44OCAxMy41M0wxNSAxNS42NlYxMEg5LjM0TDExLjQ3IDEyLjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PinInvoke = createIcon('PinInvoke', [
  [
    'path',
    {
      d: 'M22 12V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H14V6H4V18H20V12H22ZM22 7C22 5.34 20.66 4 19 4C17.34 4 16 5.34 16 7C16 8.66 17.34 10 19 10C20.66 10 22 8.66 22 7ZM11.47 12.12L8.64 14.95L10.05 16.36L12.88 13.53L15 15.66V10H9.34L11.47 12.12Z',
      key: 'v64qoz',
    },
  ],
]);

export default PinInvoke;
